<template>
  <v-dialog
    v-model="isVisible"
    persistent
    scrollable
    max-width="1800"
  >
    <v-card ref="legalCaseEditorDialogCard">
      <v-toolbar
        color="secondary"
        dark
        tile
      >
        <v-toolbar-title>
          Create an engagement letter
        </v-toolbar-title>

        <v-spacer />

        <v-btn
          icon
          @click="_ => closeDialog()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text
        class="pa-2 ma-0"
        :style="cardContentStyle"
      >
        <v-row>
          <v-col>
            <v-autocomplete
              v-model="letter.language_id"
              item-text="name"
              item-value="id"
              :items="languages"
              label="Language *"
              outlined
              :rules="[rules.required]"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              v-model="letter.content"
              label="Content *"
              outlined
              :rules="[rules.required]"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <div class="d-flex">
          <v-btn
            text
            @click="_ => closeDialog()"
          >
            Cancel
          </v-btn>

          <v-spacer />

          <v-btn
            color="success"
            :disabled="!canSave"
            @click="_ => save()"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Save
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { rules } from '@/utilities/validation-rules'

import { ENGAGEMENT_LETTER_NAMESPACE } from '@/store/engagement-letter'
import { LEGAL_CASE_NAMESPACE } from '@/store/legal-case'
import { SHARED_NAMESPACE } from '@/store/shared'

export default {
  name: 'LegalCaseEditorEngagementLetterDialog',

  model: {
    prop: 'visible',
    event: 'change',
  },

  props: {
    visible: {
      required: true,
      type: Boolean,
    },
  },

  data () {
    return {
      cardContentHeight: 350,

      letter: {
        content: null,
        language_id: null,
      },

      rules,
    }
  },

  computed: {
    cardContentStyle () {
      return `min-height: ${this.cardContentHeight}px`
    },

    isVisible: {
      get () { return this.visible },
      set (value) { this.$emit('change', value === true) },
    },

    languages () {
      return this.getCachedDropdown('languages')
    },

    ...mapGetters(LEGAL_CASE_NAMESPACE, [
      'edited',
    ]),

    ...mapGetters(SHARED_NAMESPACE, [
      'getCachedDropdown',
    ]),
  },

  created () {
    this.getDropdownOptions({ options: false, path: 'languages' })
  },

  methods: {
    canSave () {
      return this.isValid
    },

    closeDialog () {
      this.isVisible = false
    },

    save () {
      this.createEngagementLetter(this.letter).
        then(_ => {
          this.setEdited({
            ...this.edited,
            letter: { ...this.letter },
          })
          this.closeDialog()
          this.$emit('saved')
        })
    },

    ...mapActions(ENGAGEMENT_LETTER_NAMESPACE, [
      'createEngagementLetter',
    ]),

    ...mapActions(LEGAL_CASE_NAMESPACE, [
      'setEdited',
    ]),

    ...mapActions(SHARED_NAMESPACE, [
      'getDropdownOptions',
    ]),
  },
}
</script>
